import { render } from "./CreateChannel.vue?vue&type=template&id=1732618d"
import script from "./CreateChannel.vue?vue&type=script&lang=js"
export * from "./CreateChannel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__